import React, { useEffect, useState } from 'react';
import { fetchPageContent } from '../api/content';
import { defaultAboutContent } from '../content/defaultContent';
import './css/About.css';

const About = () => {
    const [content, setContent] = useState(defaultAboutContent);

    useEffect(() => {
        let active = true;
        fetchPageContent('about')
            .then((updatedContent) => {
                if (active) setContent({ ...defaultAboutContent, ...updatedContent });
            })
            .catch((error) => console.error('Unable to load updated About content.', error));
        return () => { active = false; };
    }, []);

    return (
        <main className="about-page">
            <section className="about-hero">
                <div className="about-image">
                    <img src={content.imageUrl} alt={content.imageAlt} />
                </div>
                <div className="about-text">
                    <p className="about-kicker">{content.kicker}</p>
                <h1>{content.title}</h1>
                <p>{content.intro}</p>
                    <div className="about-stat-grid" aria-label="Career highlights">
                        {content.stats.map((stat, index) => (
                            <span key={`${stat.value}-${index}`}><strong>{stat.value}</strong> {stat.label}</span>
                        ))}
                    </div>
                </div>
            </section>

            <section className="about-story">
                <div className="about-story-card">
                <h2>{content.storyTitle}</h2>
                {content.storyParagraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
                </div>
            </section>
        </main>
    );
};

export default About;
